import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
  Chip,
  Alert,
} from '@mui/material';
import {
  Build,
  Add,
  Warning,
} from '@mui/icons-material';
import { useTenant } from '../hooks/useTenant';

const Modeler: React.FC = () => {
  const { currentTenant, isTenantSelected } = useTenant();

  if (!isTenantSelected) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="warning" icon={<Warning />}>
          Selecione um tenant para acessar o Modelador
        </Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3, ml: 12.5 }}>
      {/* Header */}
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
          <Build />
          Modelador
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Modelando processos para o tenant: <strong>{currentTenant?.name}</strong>
        </Typography>
      </Box>

      {/* Content */}
      <Grid container spacing={3}>
        <Grid item xs={12} md={6} lg={4}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Modelos de Processo
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Crie e gerencie modelos de processo para automatizar fluxos de trabalho.
              </Typography>
              <Chip label="Em desenvolvimento" color="warning" size="small" />
            </CardContent>
            <CardActions>
              <Button size="small" startIcon={<Add />} disabled>
                Criar Modelo
              </Button>
            </CardActions>
          </Card>
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Templates
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Utilize templates pré-definidos para acelerar a criação de processos.
              </Typography>
              <Chip label="Em desenvolvimento" color="warning" size="small" />
            </CardContent>
            <CardActions>
              <Button size="small" startIcon={<Add />} disabled>
                Explorar Templates
              </Button>
            </CardActions>
          </Card>
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Validações
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Configure regras de validação para garantir a qualidade dos dados.
              </Typography>
              <Chip label="Em desenvolvimento" color="warning" size="small" />
            </CardContent>
            <CardActions>
              <Button size="small" startIcon={<Add />} disabled>
                Configurar Validações
              </Button>
            </CardActions>
          </Card>
        </Grid>
      </Grid>

      {/* Coming Soon */}
      <Paper sx={{ p: 3, mt: 3, textAlign: 'center' }}>
        <Typography variant="h6" gutterBottom>
          🚧 Funcionalidade em Desenvolvimento
        </Typography>
        <Typography variant="body1" color="text.secondary">
          O Modelador está sendo desenvolvido e estará disponível em breve.
          Aqui você poderá criar e gerenciar modelos de processo de forma visual e intuitiva.
        </Typography>
      </Paper>
    </Box>
  );
};

export default Modeler;
